import { ContributionEdge } from 'core/graphql';
import { IDebtor } from 'types';
import { formatMoneyCurrency } from 'core/utils/format';
import { personName } from 'core/utils/personName';
import i18n from '../../../i18n';

export const toIDebtor = (
  edge: ContributionEdge | null,
): IDebtor | undefined => {
  if (!edge) return;
  const { node } = edge;
  if (node) {
    const { currency } = node.agreement;
    return {
      id: node.id,
      name: personName(node.person),
      contractId: node.agreementTitle!,
      phone: node.person?.phone!,
      group: node.group?.name!,
      paymentDate: node.date,
      expiredDays: `${String(node.delay)!} ${i18n.t('common.day')}`,
      // `remainder` is a FloatField — rendered raw it prints
      // «1234.5600000000002 PLN». Every other money cell goes through the
      // shared formatter (thousands separator + 2 decimals).
      amount: formatMoneyCurrency(Number(node.remainder) || 0, currency),
      payments: [],
    };
  }
};
